export enum DescriptorTab {
  AUTHORS = 'descriptor_tab_authors',
  TOPIC = 'descriptor_tab_topic',
  GENRE = 'descriptor_tab_genre',
  PUBLIC_DATASET = 'descriptor_tab_public_dataset'
}
